import { Filters } from './Filters';
import { Table } from './Table';

export const ToReviewTable = () => {
  return (
    <>
      <Filters />
      <Table />
    </>
  );
};
